export function getUrl() {
  return 'https://square.hej.so/';
}
